import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { auth, db } from '../../firebase';
import * as routes from '../../constants/routes';
import { SignInLink } from './Links';

import setupData from 'setup';

const INITIAL_STATE = {
  companyname: '',
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
};

const INITIAL_STATE_TEST = {
  companyname: 'Test Domain',
  username: 'Test User',
  email: Date.now() + '@couraggo.com',
  passwordOne: 'ffffff',
  passwordTwo: 'ffffff',
  error: null,
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing.unit*6,
    marginRight: theme.spacing.unit*6,
    marginBottom: theme.spacing.unit*6,
  },
  passwordForget: {
    alignSelf: "flex-end",
    marginTop: theme.spacing.unit,
  },
  button: {
    marginTop: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
  },
  signIn: {
    alignSelf: "flex-end",
  }
});

class SignUpForm extends Component {
  constructor(props) {
    super(props);

    //this.state = { ... INITIAL_STATE_TEST };
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      companyname,
      username,
      email,
      passwordOne,
    } = this.state;

    const {
      history,
    } = this.props;

    let uid;
    let oid;
    let uniqueDomain;
    //TODO: extract out business logic to keep component lightweight.
    //move to redux
    auth.doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        uid = authUser.uid;
        return db.createOrganization({ about: { name: companyname} });
      })
      .then(result => {
        oid = result.key;
        const user = {
          profile: {
            username,
            email
          },
          organizations: {
            [oid]: {
              role: "admin"
            }
          }
        };

        return db.createUser(uid, user);

      })
      .then(() => db.getOrgDomains())
      .then((snapshot) => {

        const baseDomain = companyname.replace(/\s/g, '').toLowerCase();
        const orgDomains = [];
        snapshot.forEach(childSnapshot => {
          const orgDomain = childSnapshot.val();
          //console.log("orgDomain:", orgDomain);
          orgDomains.push(orgDomain.subDomain);
        });

        //console.log("orgDomains array:", orgDomains);
        //stupid hack to make the domain name unique
        let i = 0;
        //console.log("TEST11232:", baseDomain + (i ? i : ''));
        while (orgDomains.includes(baseDomain + (i ? i : ''))) {
          i++;
        }
        uniqueDomain = baseDomain + (i ? i : '');
        //console.log("unique domain:", uniqueDomain);

        return db.createOrgDomain({
          oid,
          subDomain: uniqueDomain,
          subDomainStatus: "pending"
        });
      })
      .then(() => {
        return db.setWebsiteRoot(oid, {
          companyName: companyname,
          contactName: username,
          subDomain: uniqueDomain,
          email: email
        });
      })
      .then(() => {
        return db.setTaxRules(oid, setupData.appData.taxRules);
      })
      .then(() => {
        const promises = [];
        const taxCategories = setupData.appData.taxCategories;
        taxCategories.forEach(taxCategory => {
          promises.push(db.createTaxCategoryWithOID(oid, taxCategory));
        });

        return Promise.all(promises);
      })
      .then(() => {
        return db.createWorkType({
          name: "Default",
          rate: "50"
        });
      })
      .then(() => {
        return db.createCrew({
          crewFirstName: "Default"
        });
      })
      .then(() => {
        return db.getWebsiteImages().once('value');
      })
      .then(snapshot => {
        const websiteImages = snapshot.val();
        //console.log("snapshot of images:", websiteImages);
        if (websiteImages) {
          return websiteImages;
        } else {
          const contact = [
            { filename: "contact1.jpg" },
            { filename: "contact2.jpg" },
            { filename: "contact3.jpg" },
          ];
          const hero = [
            { filename: "hero1.jpg" },
            { filename: "hero2.jpg" },
            { filename: "hero3.jpg" },
          ];

          return db.createWebsiteImages({
            contact: contact,
            hero: hero
          });
        }
      })
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.ADMIN);
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      companyname,
      username,
      email,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;
    const { classes } = this.props;

    const isInvalid =
      companyname === '' ||
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      username === '';

    return (
      <form className={classes.root} onSubmit={this.onSubmit}>
        <TextField
          label="Your Name"
          value={username}
          onChange={event => this.setState(byPropKey('username', event.target.value))}
          margin="normal"
        />
        <TextField
          label="Company"
          value={companyname}
          onChange={event => this.setState(byPropKey('companyname', event.target.value))}
          margin="normal"
        />
        <TextField
          label="Email"
          value={email}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          value={passwordOne}
          onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
          margin="normal"
        />
        <TextField
          label="Confirm Password"
          type="password"
          value={passwordTwo}
          onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
          margin="normal"
        />

        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disabled={isInvalid}
          type="submit"
        >
          Start Trial
        </Button>
        <div className={classes.signIn}><SignInLink /></div>

        { error && <p>{error.message}</p> }
      </form>
    );
  }
}

export default withStyles(styles)(SignUpForm);



// WEBPACK FOOTER //
// ./src/components/auth/SignUpForm.jsx